import { SafetyObject } from '@/utils/types';

export function cloneStruct<T extends SafetyObject>(obj: T): T {
  return JSON.parse(JSON.stringify(obj));
}

export function compareObjects<T>(obj1: T, obj2: T): boolean {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
}
